import React from 'react'
import classNames from 'classnames'
import Button from '../../Button'
import strings from '../../../../../strings'

import './styles.less'

interface Props {
	className?: string
	ariaLabel?: string
	onClick?: React.MouseEventHandler<HTMLIonButtonElement>
}

const MapButton: React.FC<Props> = ({ className, ariaLabel = strings.open_map, onClick }) => (
	<Button className={classNames('map-button', className)} ariaLabel={ariaLabel} onClick={onClick}>
		<i className="fas fa-map-marked-alt" />
	</Button>
)

export default React.memo(MapButton)
